import type { TWellCorrelationSerializedInternalState } from './WellCorrelationWidget.entity';

export function parseWellCorrelationWidgetInternalState(state: object): TWellCorrelationSerializedInternalState {
  let wellId: number | null = null;
  let stateParams: object = {};

  if ('wellId' in state && typeof state.wellId === 'number') {
    wellId = state.wellId;
  }

  if ('stateParams' in state && typeof state.stateParams === 'object' && !!state.stateParams) {
    stateParams = state.stateParams;
  }

  return {
    wellId,
    stateParams,
  };
}
